import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Environment as confirmed by the server: GET /api/ → { service, env, status }. Never derived from the browser address.
// Only these exact values are recognised; anything else, an error or no answer within the timeout is "unknown".
const ENV_KEYS = new Map([["production", "production"], ["preview", "preview"], ["test", "test"], ["development", "dev"], ["dev", "dev"]]);
const ENV_TIMEOUT_MS = 5000;
const LOADING = { status: "loading", env: null, labelKey: null };
let pending = null;

export function envStatus(data) {
  const env = typeof data?.env === "string" ? ENV_KEYS.get(data.env) : undefined;
  if (env === undefined) return { status: "unknown", env: null, labelKey: "app.env_unknown" };
  return { status: env === "production" ? "production" : "non_production", env, labelKey: `app.env_${env}` };
}

export function loadRuntimeEnv() {
  if (!pending) {
    pending = api.get("/", { timeout: ENV_TIMEOUT_MS })
      .then(({ data }) => envStatus(data))
      .catch(() => envStatus(null));
    pending.then((s) => { if (s.status === "unknown") pending = null; });
  }
  return pending;
}

export function useRuntimeEnv() {
  const [state, setState] = useState(LOADING);
  useEffect(() => {
    let active = true;
    loadRuntimeEnv().then((s) => { if (active) setState(s); });
    return () => { active = false; };
  }, []);
  return state;
}
